import { css } from '@emotion/react'
import type { ReactElement } from 'react'

import { Spinner, spacing, Text } from '@orus.eu/pharaoh'

import { Center } from './center.tsx'

type GlobalLoadingStateProps = {
  text?: string
}

export function GlobalLoadingState({ text }: GlobalLoadingStateProps): ReactElement {
  return (
    <Center minHeight="80vh">
      <Spinner size="70" />
      {text ? (
        <Text
          variant="h2"
          css={css`
            margin-top: ${spacing[70]};
          `}
        >
          {text}
        </Text>
      ) : null}
    </Center>
  )
}
